import { render } from "./Employees.vue?vue&type=template&id=61996917"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__